import React, { Component } from "react";
import "./bedmap.css";



export default class BedMap extends Component{
  constructor(props) {
    super(props);

  }

  componentDidMount(){
  }

  componentDidUpdate(){
  }

getColor=(c,r,x,y)=>{

  if(c==x && r==y){

    return "RED"
  }
  return "NORMAL"


}


  render(){


      let c=parseInt(this.props.x/10)
      let r=parseInt(this.props.y/10)

      if(c==10)
        c-=1
      if(r==10)
        r-=1

      //console.log(c+","+r)

      return(<div>



        <table class="bedheatmap">
          <tr><td className={this.getColor(c,r,0,0)}></td><td className={this.getColor(c,r,1,0)}></td><td className={this.getColor(c,r,2,0)}></td><td className={this.getColor(c,r,3,0)}></td><td className={this.getColor(c,r,4,0)}></td><td className={this.getColor(c,r,5,0)}></td><td className={this.getColor(c,r,6,0)}></td><td className={this.getColor(c,r,7,0)}></td><td className={this.getColor(c,r,8,0)}></td><td className={this.getColor(c,r,9,0)}></td> </tr>
          <tr><td className={this.getColor(c,r,0,1)}></td><td className={this.getColor(c,r,1,1)}></td><td className={this.getColor(c,r,2,1)}></td><td className={this.getColor(c,r,3,1)}></td><td className={this.getColor(c,r,4,1)}></td><td className={this.getColor(c,r,5,1)}></td><td className={this.getColor(c,r,6,1)}></td><td className={this.getColor(c,r,7,1)}></td><td className={this.getColor(c,r,8,1)}></td><td className={this.getColor(c,r,9,1)}></td> </tr>
          <tr><td className={this.getColor(c,r,0,2)}></td><td className={this.getColor(c,r,1,2)}></td><td className={this.getColor(c,r,2,2)}></td><td className={this.getColor(c,r,3,2)}></td><td className={this.getColor(c,r,4,2)}></td><td className={this.getColor(c,r,5,2)}></td><td className={this.getColor(c,r,6,2)}></td><td className={this.getColor(c,r,7,2)}></td><td className={this.getColor(c,r,8,2)}></td><td className={this.getColor(c,r,9,2)}></td> </tr>
          <tr><td className={this.getColor(c,r,0,3)}></td><td className={this.getColor(c,r,1,3)}></td><td className={this.getColor(c,r,2,3)}></td><td className={this.getColor(c,r,3,3)}></td><td className={this.getColor(c,r,4,3)}></td><td className={this.getColor(c,r,5,3)}></td><td className={this.getColor(c,r,6,3)}></td><td className={this.getColor(c,r,7,3)}></td><td className={this.getColor(c,r,8,3)}></td><td className={this.getColor(c,r,9,3)}></td> </tr>
          <tr><td className={this.getColor(c,r,0,4)}></td><td className={this.getColor(c,r,1,4)}></td><td className={this.getColor(c,r,2,4)}></td><td className={this.getColor(c,r,3,4)}></td><td className={this.getColor(c,r,4,4)}></td><td className={this.getColor(c,r,5,4)}></td><td className={this.getColor(c,r,6,4)}></td><td className={this.getColor(c,r,7,4)}></td><td className={this.getColor(c,r,8,4)}></td><td className={this.getColor(c,r,9,4)}></td> </tr>
          <tr><td className={this.getColor(c,r,0,5)}></td><td className={this.getColor(c,r,1,5)}></td><td className={this.getColor(c,r,2,5)}></td><td className={this.getColor(c,r,3,5)}></td><td className={this.getColor(c,r,4,5)}></td><td className={this.getColor(c,r,5,5)}></td><td className={this.getColor(c,r,6,5)}></td><td className={this.getColor(c,r,7,5)}></td><td className={this.getColor(c,r,8,5)}></td><td className={this.getColor(c,r,9,5)}></td> </tr>
          <tr><td className={this.getColor(c,r,0,6)}></td><td className={this.getColor(c,r,1,6)}></td><td className={this.getColor(c,r,2,6)}></td><td className={this.getColor(c,r,3,6)}></td><td className={this.getColor(c,r,4,6)}></td><td className={this.getColor(c,r,5,6)}></td><td className={this.getColor(c,r,6,6)}></td><td className={this.getColor(c,r,7,6)}></td><td className={this.getColor(c,r,8,6)}></td><td className={this.getColor(c,r,9,6)}></td> </tr>
          <tr><td className={this.getColor(c,r,0,7)}></td><td className={this.getColor(c,r,1,7)}></td><td className={this.getColor(c,r,2,7)}></td><td className={this.getColor(c,r,3,7)}></td><td className={this.getColor(c,r,4,7)}></td><td className={this.getColor(c,r,5,7)}></td><td className={this.getColor(c,r,6,7)}></td><td className={this.getColor(c,r,7,7)}></td><td className={this.getColor(c,r,8,7)}></td><td className={this.getColor(c,r,9,7)}></td> </tr>
          <tr><td className={this.getColor(c,r,0,8)}></td><td className={this.getColor(c,r,1,8)}></td><td className={this.getColor(c,r,2,8)}></td><td className={this.getColor(c,r,3,8)}></td><td className={this.getColor(c,r,4,8)}></td><td className={this.getColor(c,r,5,8)}></td><td className={this.getColor(c,r,6,8)}></td><td className={this.getColor(c,r,7,8)}></td><td className={this.getColor(c,r,8,8)}></td><td className={this.getColor(c,r,9,8)}></td> </tr>
          <tr><td className={this.getColor(c,r,0,9)}></td><td className={this.getColor(c,r,1,9)}></td><td className={this.getColor(c,r,2,9)}></td><td className={this.getColor(c,r,3,9)}></td><td className={this.getColor(c,r,4,9)}></td><td className={this.getColor(c,r,5,9)}></td><td className={this.getColor(c,r,6,9)}></td><td className={this.getColor(c,r,7,9)}></td><td className={this.getColor(c,r,8,9)}></td><td className={this.getColor(c,r,9,9)}></td> </tr>
        </table>





        {this.props.x} , {this.props.y}
        </div>

      )

  }
}



// WEBPACK FOOTER //
// ./src/programmerComponents/BedMap.js